module.exports = __webpack_public_path__ + "img/pot.58d984d0.png";